import React from 'react';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import styles from './CheckingEligibility.module.css';
import Spinner from '../../../components/Spinner';
import messages from '../AutomatedLendingDecision.messages';

const mapStateToProps = (state) => ({
    isOnFinalStep: state.ui.activeStep.id === 'businessAccounts'
});

const CheckingEligibility = ({ isOnFinalStep }) => {
    let informationText = (
        <FormattedMessage {...messages.checkingApplication} />
    );

    if (isOnFinalStep) {
        informationText = (
            <FormattedMessage {...messages.completingApplication} />
        );
    }

    return (
        <div className={styles.container}>
            <Spinner className={styles.spinner} data-testid="pending-spinner" />
            <h1 className={styles.checkingApplicationText}>
                {informationText}
            </h1>
            <p>
                <FormattedMessage {...messages.waitingTime} />
            </p>
        </div>
    );
};

export default connect(mapStateToProps)(CheckingEligibility);
